import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Styling } from 'seth-content-rich-text/lib/content.model';

@Injectable({
  providedIn: 'root',
})
export class FormattingService {

  constructor (private _sanitizer: DomSanitizer) { }

  formatText(content: string, code: Styling[]): SafeHtml {
    return this._sanitizer.sanitize(SecurityContext.HTML,
      this.addStyles(content, code)) || 'Unsafe HTML detected.';
  }

  addStyles(text: string, codes: Styling[]): string {
    let formattedText = text;
    let lastIndex = 0;
    let start = '';
    for (const code of codes) {
      const startPosition = lastIndex;
      let position = formattedText.indexOf(code.styledText, startPosition);
      if (position === -1) continue;

      position = this.ignoreStyledText(formattedText, code.style, position);

      start = formattedText.slice(0, position);
      const styledText = this.wrapTextWithStyle(code.styledText, code.style);
      const end = formattedText.slice(position + code.styledText.length);
      lastIndex = position + styledText.length;

      formattedText = start + styledText + end;
    }
    return formattedText;
  }

  ignoreStyledText(text: string, tag: string, position: number): number {
    const start = text.indexOf(this.getTag(tag), position);
    if(start === -1) return position;
    const end = text.indexOf(`</`, start) + 2;
    if(end === -1) return position;
    if (position >= start && position <= end) return end;
    return position;
  }

  wrapTextWithStyle(text: string, style: string): string {
    switch (style) {
      case 'bold': return `<strong>${text}</strong>`;
      case 'italic': return `<em>${text}</em>`;
      case 'underline': return `<u>${text}</u>`;
      case 'strikethrough': return `<s>${text}</s>`;
      case 'superscript': return `<sup>${text}</sup>`;
      case 'subscript': return `<sub>${text}</sub>`;
      default: return text;
    }
  }

  getTag(style: string): string {
    switch (style) {
      case 'bold': return '<strong>';
      case 'italic': return '<i>';
      case 'underline': return '<u>';
      case 'strikethrough': return '<s>';
      case 'superscript': return '<sup>';
      case 'subscript': return '<sub>';
      default: return '';
    }
  }
}
